import React, { useRef, useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import { PlusPlansFeatures, SubscribeProcess, awnPlusAnnualMonthlySwitchAvail, displayCancelPlusOnIosMessage, getAllPlusSubs, getAwnPlusAppPrice, getAwnTeamsAppPrice, plusSubHasCode, showAwnFreeTrial, subIsAndroid, subIsIap, subIsIos, subIsMonthly, subIsTeams, getSubscriptionDisplayName, getSubscriptionConfig, SmsAutoRefillToggle, triggerNativeIAP, createSubscriptionPriceGetter, doAppVersionRedirect } from './';
import { Link } from 'react-router-dom';
import Switch from 'react-switch'
import classNames from 'classnames';
import { filter, intersection, map, path, pipe } from 'ramda';
import { useDoModal } from '../user/redux/doModal';
import bindDeviceActions from '../device/redux/bindDeviceActions';
import { AmbRadio, Loader } from '../../components';
import { isApp } from '../../common/ambient';
import { isIosApp, isAndroidApp } from '../../common/ambient/utils';
import { usePaymentPolling } from './usePaymentPolling';

const awnsOnly = pipe(
  filter(sub => /^awn-plus-/.test(sub.productName)),
  filter(sub => sub.status !== 'incomplete'),
  map(sub => sub.productName)
)

function PlusSubscriptionModal ({ user, message, device, actions, userActions, redeemCode, code, stepTwo, tier, forceChange, initialAnnual }) {
  const subscribedWithCode = plusSubHasCode(user)
  const [annual, setAnnual] = useState(initialAnnual !== undefined ? initialAnnual : true)
  const [plusUserSwitch, setPlusUserSwitch] = useState(forceChange || false)
  const [step, setStep] = useState((code && !user.plus) || (stepTwo && !forceChange) ? 2 : 1)
  const [_redeemCode, setRedeemCode] = useState(redeemCode)
  const [selectedTier, setSelectedTier] = useState(tier || 'plus') // 'plus' or 'teams'

  // Determine if this is an upgrade or downgrade based on current subscription and target tier
  const isUpgrade = (tier === 'teams' || selectedTier === 'teams') && (!user.plus || !subIsTeams(user.plus))
  const isDowngrade = (tier === 'plus' || selectedTier === 'plus') && user.plus && subIsTeams(user.plus)
  const [wantsGiftCode, setWantsGiftCode] = useState(redeemCode || false)
  const [showPaymentMethodChoice, setShowPaymentMethodChoice] = useState(false)
  const [paymentMethodChosen, setPaymentMethodChosen] = useState(null) // 'iap' or 'cc'
  const { doModal } = useDoModal()
  const userSubscriptionsRef = useRef()
  const { paymentComplete, appRefreshingUser } = device

  // Payment polling hook
  const { startPolling, stopPolling, isPolling } = usePaymentPolling(actions)

  useEffect(() => {
    actions.setThing('paymentComplete', false)
    userActions.refreshUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Only run once on mount - actions and userActions are stable

  // Watch for user.plus appearing while polling (payment success)
  useEffect(() => {
    if (user.plus && isPolling()) {
      stopPolling(true) // Stop polling and set paymentComplete
    }
  }, [user.plus, isPolling, stopPolling])
  useEffect(() => {
    const currentSubscriptions = awnsOnly(path(['info', 'payments', 'subscriptions'], user) || [])
    const lastSubscriptions = awnsOnly(userSubscriptionsRef.current || [])
    
    if (intersection(currentSubscriptions, lastSubscriptions).length !== currentSubscriptions.length) {
      // Only reset plusUserSwitch if we're not forcing a change
      if (plusUserSwitch && !forceChange) {
        setPlusUserSwitch(false)
      }
      // Only reset step if we're not forcing a change and we have previous subscriptions
      if (userSubscriptionsRef.current && !forceChange) {
        setStep(1)
      }
    }
    userSubscriptionsRef.current = path(['info', 'payments', 'subscriptions'], user) || []
  }, [user, plusUserSwitch, setPlusUserSwitch, forceChange])
  
  // Handle payment method selection for app users
  const handlePaymentMethodChoice = (method) => {
    setPaymentMethodChosen(method)
    setShowPaymentMethodChoice(false)
    
    if (method === 'iap') {
      // Trigger IAP flow immediately
      const isTeamsTier = selectedTier === 'teams'
      const subscriptionTerm = annual ? 'yearly' : 'monthly'
      const productName = `awn-plus-${isTeamsTier ? 'for-teams' : 'account'}-${subscriptionTerm}`
      const userId = path(['info', '_id'], user)

      if (doAppVersionRedirect(productName)) {
        return
      }
      
      const success = triggerNativeIAP(productName, userId)
      if (!success) {
        // Fallback: show error or proceed to CC flow
        console.error('Failed to trigger native IAP, falling back to CC flow')
        setWantsGiftCode(false)
        setStep(2)
      }
    } else {
      // For CC, proceed to SubscribeProcess step
      setWantsGiftCode(false)
      setStep(2)
    }
  }
  
  // Helper function to get the right price to display
  const getSubscriptionPriceDisplay = createSubscriptionPriceGetter(device)
  
  // Helper to determine if SMS toggle should be shown
  const shouldShowSmsToggle = !!path(['info', 'payments', 'defaultPaymentMethod'], user) || subIsTeams(user.plus)

  const term = annual ? 'yearly' : 'monthly'
  const freeTrialAvail = showAwnFreeTrial(user)
  const active = false
  const btnLabel = freeTrialAvail ? 'Try 1 month free' : 'Upgrade'

  const upgradeButtonOnClick = (tier) => {
    setSelectedTier(tier)
    let showPaymentChoice = (isIosApp() || isAndroidApp()) && !code
    if (isAndroidApp() && device?.countryCode?.code && !['US', 'RU', 'IN'].includes(device?.countryCode?.code)) {
      showPaymentChoice = false
      console.log(device?.countryCode?.code + ' is not US, RU or IN')
    }
    if (showPaymentChoice) {
      setShowPaymentMethodChoice(true)
    } else {
      setWantsGiftCode(false)
      setStep(2)
    }
  }

  const showPlans = (
    <>
      <div className={classNames('switch-wrap global-toggle', annual ? 'annual' : 'monthly')}>
        <div className={classNames('switch-container', annual ? 'annual' : 'monthly')}>
          <span className='slider' />
          <button
            className={`toggle-btn ${annual ? 'active' : ''}`}
            onClick={() => setAnnual(true)}
          >
            Annual
          </button>
          <button
            className={`toggle-btn ${!annual ? 'active' : ''}`}
            onClick={() => setAnnual(false)}
          >
            Monthly
          </button>
        </div>
        <span className='discount'>Save 17%</span>
      </div>
      <div className='product-tiers'>
        <div className={classNames(`tier tier-1 step-${step}`, { active, annual, trial: freeTrialAvail })}>
          <div className='top'>
            <h3>AWN+ Individual</h3>
            <h2>
              {(() => {
                const pricing = getSubscriptionPriceDisplay('plus', annual, false)
                return <>{pricing.monthlyPrice}<span className='per-month'>/month</span></>
              })()}
            </h2>
            {annual && (() => {
              const pricing = getSubscriptionPriceDisplay('plus', annual, false)
              return <p className='billed-annually'>{pricing.billedText}</p>
            })()}
            <button
              className='btn btn-white'
              onClick={() => upgradeButtonOnClick('plus')}
            >{btnLabel}</button>
            <p>
              <a onClick={() => {
                setAnnual(true)
                setSelectedTier('plus')
                setWantsGiftCode(true)
                setStep(2)
              }}>Enter Gift code</a>
            </p>
            {/* {freeTrialAvail && <p className='trial'>Limited Time Offer - First Month Free!</p>} */}
          </div>
          <div className='bottom'>
            Best for individuals who need deeper insights, longer forecasts, and more advanced data tools.

          </div>
        </div>
        <div className={classNames(`tier tier-2 step-${step}`, { active, annual })}>
          <div className='top'>
            <h3>AWN+ Teams</h3>
            <h2>
              {(() => {
                const pricing = getSubscriptionPriceDisplay('teams', annual, false)
                return <>{pricing.monthlyPrice}<span className='per-month'>/month</span></>
              })()}
            </h2>
            {annual && (() => {
              const pricing = getSubscriptionPriceDisplay('teams', annual, false)
              return <p className='billed-annually'>{pricing.billedText}</p>
            })()}
            <button
              className='btn btn-white'
              onClick={() => upgradeButtonOnClick('teams')}
            >{btnLabel}</button>
            <p>
              <a onClick={() => {
                setAnnual(true)
                setSelectedTier('teams')
                setWantsGiftCode(true)
                setStep(2)
              }}>Enter Gift code</a>
            </p>
          </div>
          <div className='bottom'>
            Ideal for teams and small businesses who need advanced tools, team management, and extended data history.
          </div>
        </div>
      </div>
      <div className='features'>
        <h3>AWN+ Plan Features</h3>
        <PlusPlansFeatures 
          onClick={upgradeButtonOnClick}
        />
      </div>
    </>
  )
  let header = (
    <h2>{message || 'Expanded Layers, Extended History, Precision Forecast'}</h2>
  )
  // Calculate prices for payment method selection
  let paymentMethodSelectionUI = ''
  if (showPaymentMethodChoice) {
    const isTeamsTier = selectedTier === 'teams'
    const subscriptionConfig = getSubscriptionConfig(`awn-plus-${isTeamsTier ? 'for-teams' : 'account'}-${term}`)
    const regularPrice = subscriptionConfig ? parseFloat(subscriptionConfig.price.replace(/[^0-9.]/g, '')) : 0
    const discountedPrice = (regularPrice * 0.8).toFixed(2)
    // Only use app price for IAP option
    const iapPricing = getSubscriptionPriceDisplay(selectedTier, annual, true)
    const appPrice = iapPricing.price.split('/')[0]
    
    
    paymentMethodSelectionUI = (
      <div className='payment-method-selection'>
        
        <div className='payment-options'>
          
          <div onClick={() => handlePaymentMethodChoice('cc')} className='payment-option cc-option recommended'>
            <span className='badge'>SAVE 20%</span>
            <h4>{subscriptionConfig.displayName} {annual ? 'Annual' : 'Monthly'}</h4>
            <div className='price'>
              <span className='discounted'>${discountedPrice}/{annual ? 'year' : 'month'}<sup>*</sup></span>
            </div>
            <button 
              className='btn btn-primary'
            >
              Subscribe with <i className='icon awn' />
            </button>
            <p>Manage subscription through AWN</p>
          </div>
          <div onClick={() => handlePaymentMethodChoice('iap')} className='payment-option iap-option'>
            <h4>{subscriptionConfig.displayName} {annual ? 'Annual' : 'Monthly'}</h4>
            <div className='price'>{appPrice}/{annual ? 'year' : 'month'}</div>
            <button 
              className='btn'
              >
              Subscribe with <i className={classNames('icon', isIosApp() ? 'apple' : 'google')}/> {isIosApp() ? 'Apple' : 'Google'}.
            </button>
            <p>Manage subscription through  {isIosApp() ? 'Apple' : 'Google'} Store</p>
          </div>
        </div>
        
        <p className='fine-print'>
          <sup>*</sup> Secure payment by credit/debit card. 20% off your first billing cycle. Renews at ${regularPrice}/{annual ? 'year' : 'month'} unless cancelled.
        </p>
        <button 
          className='btn btn-link'
          onClick={() => setShowPaymentMethodChoice(false)}
        >
          Back 
        </button>
      </div>
    )
  }

  let show = ''
  if (paymentComplete) {
    if (!user.plus || appRefreshingUser) {
      show = (
        <div className='awn-plus-member'>
          <div className='box'>
            <h2>Processing...</h2>
            <p>Your subscription is being activated. This may take a few moments.</p>
            <Loader />
          </div>
        </div>
      )
    } else {
      const subscriptionName = getSubscriptionDisplayName(user.plus)

      show = (
        <div className='awn-plus-member giftCode'>
          <div className='box'>
            <h2>Thank you for your purchase!</h2>
            <p>You have successfully subscribed to {subscriptionName}</p>
            <p><strong>Renews: </strong> {moment(user.plus.currentPeriodEnd * 1000).format('MMM, D, YYYY')}</p>
            {shouldShowSmsToggle && <SmsAutoRefillToggle user={user} userActions={userActions} />}
            <div className='btns text-center'>
              <a className='btn-primary btn' onClick={() => doModal(null)}>Close</a>
            </div>
          </div>
        </div>
      )
    }
  } else if ((user.plus && !plusUserSwitch && !_redeemCode) || (subscribedWithCode && !forceChange)) {
    let plan = ''
    const monthlyChosen = subIsMonthly(user.plus)
    if (/free/.test(user.plus.productName)) {
      plan = 'Free'
    } else if (awnPlusAnnualMonthlySwitchAvail(user)) {
      // Get current subscription type to maintain Teams vs regular AWN+
      const isCurrentlyTeams = subIsTeams(user.plus)
      const currentTier = isCurrentlyTeams ? 'teams' : 'plus'
      
      // Get pricing using the helper function
      const annualPricing = getSubscriptionPriceDisplay(currentTier, true, false)
      const monthlyPricing = getSubscriptionPriceDisplay(currentTier, false, false)
      const annualPrice = annualPricing.price.replace('/year', '/yr')
      const currentMonthlyPrice = monthlyPricing.price.replace('/month', '/mo')
      
      plan = (
        <div className='switch-term'>
          <AmbRadio
            selected={!monthlyChosen}
            label={(
              <>
                Annual <span className='save'>{annualPrice}</span>
              </>
            )}
            onClick={() => {
              if (!monthlyChosen) {
                return
              }
              setAnnual(true)
              setSelectedTier(currentTier)
              setPlusUserSwitch(true)
              setStep(2)
            }}
          />
          <AmbRadio
            selected={monthlyChosen}
            label={(
              <>
                Monthly <span className='save'>{currentMonthlyPrice}</span>
              </>
            )}
            onClick={() => {
              if (monthlyChosen) {
                return
              }
              setAnnual(false)
              setSelectedTier(currentTier)
              setPlusUserSwitch(true)
              setStep(2)
            }}
          />
        </div>
      )
    } else if (monthlyChosen) {
      plan = 'Monthly'
    } else {
      plan = 'Annual'
    }
    const subscriptionName = getSubscriptionDisplayName(user.plus)
    let trialShow = null 
    if (user.plus.status === 'trialing') {
      trialShow = (
        <>
          <h3>You are using the {subscriptionName} free trial!</h3>
          <p>Free trial until {moment(user.plus.currentPeriodEnd * 1000).format('M/D/YYYY')}</p>
        </>
      )
    }
    if (subscribedWithCode) {
      let warning = (
        <p><b>Renews on:</b> {moment(user.plus.currentPeriodEnd * 1000).format('M/D/YYYY')}</p>
      )
      if (displayCancelPlusOnIosMessage(user)) {
        warning = (
          <div className='warning'>
            <p>
              To avoid being charged twice, you will need to manually cancel your Apple subscription to your current plan.
            </p>
            {isIosApp() && (
              <p>
                <a href='https://apps.apple.com/account/subscriptions' target='_blank' rel='noreferrer'>Cancel your Apple subscription</a>
              </p>
            )}
          </div>
        )
      }
      trialShow = (
        <div className='success box'>
          <h2>You have successfully activated your annual free {subscriptionName} gift subscription!</h2>
          {warning}
          {shouldShowSmsToggle && <SmsAutoRefillToggle user={user} userActions={userActions} />}
        </div>
      )
    }
    show = (
      <div className={classNames('awn-plus-member', {
        switchAvail: awnPlusAnnualMonthlySwitchAvail(user),
        giftCode: subscribedWithCode
      })}>
        {trialShow}
        <div className='box plan-changer'>
          <div className='table'>
            <div>
              <span>Subscription Plan</span>
              <span>{subscriptionName}</span>
            </div>
            <div className='options'>
              <span>Billing option</span>
              <span>{plan}</span>
            </div>
            <div>
              <span>{user.plus.cancelAtPeriodEnd ? 'Expires' : 'Renews'}</span>
              <span>{user.plus.currentPeriodEnd ? moment(user.plus.currentPeriodEnd * 1000).format('M/D/YYYY') : '∞'}</span>
            </div>
          </div>
          {shouldShowSmsToggle && <SmsAutoRefillToggle user={user} userActions={userActions} />}
        </div>
        <div className='btns'>
          {!subscribedWithCode && !subIsTeams(user.plus) && (
            <>
              <a className='btn btn-primary' onClick={() => {
                setSelectedTier('teams')
                setPlusUserSwitch(true)
                setStep(1)
              }}>Upgrade to Teams</a>
              <a className='btn btn-bordered' onClick={() => {
                setRedeemCode(true)
              }}>Redeem Gift Code</a>
            </>
          )}
          {!subscribedWithCode && subIsTeams(user.plus) && (
            // AWN+ Teams users don't see any buttons
            <></>
          )}
        </div>
        <p className='manage-subscription'>
          <Link to='/account/subscriptions#subscriptions' onClick={() => doModal(null)} className=''>Manage Subscription</Link>
        </p>
      </div>
    )
  } else if (_redeemCode && step === 1) {
    const currentSubscriptionName = getSubscriptionDisplayName(user.plus)
    show = (
      <div className='dont-worry'>
        <h3>Your remaining subscription time will not be lost!</h3>
        <p>
          Please note, that when you redeem a gift code, the new annual gift subscription plan will be added to your active {currentSubscriptionName} plan.
        </p>
        <button className='btn btn-primary' onClick={() => setStep(2)}>Redeem Gift Code</button>
      </div>
    )
  } else if (showPaymentMethodChoice) {
    show = paymentMethodSelectionUI
  } else if (plusUserSwitch && step === 1 && isUpgrade) {
    // Show upgrade preview for Teams
    show = (
      <>
        <div className={classNames('switch-wrap global-toggle', annual ? 'annual' : 'monthly')}>
          <div className={classNames('switch-container', annual ? 'annual' : 'monthly')}>
            <span className='slider' />
            <button
              className={`toggle-btn ${annual ? 'active' : ''}`}
              onClick={() => setAnnual(true)}
            >
              Annual
            </button>
            <button
              className={`toggle-btn ${!annual ? 'active' : ''}`}
              onClick={() => setAnnual(false)}
            >
              Monthly
            </button>
          </div>
          <span className='discount'>Save 17%</span>
        </div>
        <div className='product-tiers preview'>
          <div className={classNames(`tier preview-tier tier-2 step-${step}`, { annual })}>
            <div className='top'>
              <h3>AWN+ Teams</h3>
              <h2>
                {(() => {
                  const pricing = getSubscriptionPriceDisplay('teams', annual, false)
                  return <>{pricing.monthlyPrice}<span className='per-month'>/month</span></>
                })()}
              </h2>
              {annual && (() => {
                const pricing = getSubscriptionPriceDisplay('teams', annual, false)
                return <p className='billed-annually'>{pricing.billedText}</p>
              })()}
              <button
                className='btn btn-white'
                onClick={() => handlePaymentMethodChoice(subIsIap(user.plus) ? 'iap' : 'cc')}
              >
                Upgrade to Teams
              </button>
            </div>
            <div className='bottom'>
              <h3>Enhance your experience</h3>
              <div className='group'>
                <div className='line'>
                  <div className='label'>Upgrade Features</div>
                  <div className='val plus'>
                    <strong>Weather Forecast: </strong>
                    15 Days
                  </div>
                  <div className='val plus'>
                    <strong>Data History: </strong>
                    5 years
                  </div>
                </div>
                <div className='line'>
                  <div className='label'>New Features</div>
                  <div className='val plus'>
                    <strong>
                      Team Alerts: </strong>
                    Organize weather alerts for a team. As an admin, you can create custom alert sets and assign them to members, who will receive alerts via email, SMS, or in-app.
                  </div>
                  <div className='val plus'>
                    <strong>Map Filtering: </strong>
                    Customize the stations shown on the map. Select from your own stations, favorited ones, and NOAA sources
                  </div>
                </div>
                <div className='line'>
                  <strong>Your remaining subscription time will not
be lost.</strong><br/><br/>
                  <p>
                    We'll prorate the change by calculating the unused portion of your current subscription and applying it as a credit to your account.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  } else if (plusUserSwitch && step === 1 && isDowngrade) {
    // Show downgrade preview for Individual
    show = (
      <>
        <div className={classNames('switch-wrap global-toggle', annual ? 'annual' : 'monthly')}>
          <div className={classNames('switch-container', annual ? 'annual' : 'monthly')}>
            <span className='slider' />
            <button
              className={`toggle-btn ${annual ? 'active' : ''}`}
              onClick={() => setAnnual(true)}
            >
              Annual
            </button>
            <button
              className={`toggle-btn ${!annual ? 'active' : ''}`}
              onClick={() => setAnnual(false)}
            >
              Monthly
            </button>
          </div>
          <span className='discount'>Save 17%</span>
        </div>
        <div className='product-tiers preview'>
          <div className={classNames(`tier preview-tier tier-1 step-${step}`, { annual })}>
            <div className='top'>
              <h3>AWN+ Individual</h3>
              <h2>
                {(() => {
                  const pricing = getSubscriptionPriceDisplay('plus', annual, false)
                  return <>{pricing.monthlyPrice}<span className='per-month'>/month</span></>
                })()}
              </h2>
              {annual && (() => {
                const pricing = getSubscriptionPriceDisplay('plus', annual, false)
                return <p className='billed-annually'>{pricing.billedText}</p>
              })()}
              <button
                className='btn btn-white'
                onClick={() => handlePaymentMethodChoice(subIsIap(user.plus) ? 'iap' : 'cc')}
              >
                Downgrade to Individual
              </button>
            </div>
            <div className='bottom'>
              <h3>Do you want to downgrade to AWN+ Individual Plan?</h3>
              <div className='group'>
                <div className='line'>
                  <div className='label'>Changes to your features</div>
                  <div className='val minus'>
                    <strong>Weather Forecast: </strong>
                    Reduced to 10 Days
                  </div>
                  <div className='val minus'>
                    <strong>Data History: </strong>
                    Reduced to 3 years
                  </div>
                </div>
                <div className='line'>
                  <div className='label'>You will also lose access to the following features:</div>
                  <div className='val minus'>
                    <strong>Team Alerts: </strong>
                    Team alert management and member assignment will no longer be available.
                  </div>
                  <div className='val minus'>
                    <strong>Advanced Map Filtering: </strong>
                    Advanced filtering options for map stations will be removed.
                  </div>
                </div>
                <div className='line'>
                  <strong>Your remaining subscription time will not be lost.</strong><br/><br/>
                  <p>
                    We'll prorate the change by calculating the unused portion of your current subscription and applying it as a credit to your account.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  } else if (step === 1) {
    show = showPlans
  } else if (step === 2) {
    let proRate = ''
    if (!isApp() && plusUserSwitch) {
      const currentlyMonthly = subIsMonthly(user.plus)
      const switchingToAnnual = annual
      
      if (currentlyMonthly && switchingToAnnual) {
        // Monthly to Annual
        proRate = (
          <p className='prorate'>Your account will be prorated for the remaining time on your current monthly subscription. This means we'll credit the unused portion of your monthly plan against the cost of the yearly plan. You'll only be charged the difference. Enjoy the savings that come with your yearly subscription!</p>
        )
      } else if (!currentlyMonthly && !switchingToAnnual) {
        // Annual to Monthly
        proRate = (
          <p className='prorate'>
            Since you’re switching to a monthly billing, the unused portion of your annul plan will be converted as account credit. This credit will automatically cover future monthly payments until it’s used up.
          </p>
        )
      }
    }
    const tierName = selectedTier === 'teams' ? 'AWN+ Teams' : 'AWN+'
    header = (
      <>
        <h2>{tierName} {annual ? 'Annual' : 'Monthly'} subscription plan</h2>
        <h3>{message || 'Expanded Layers, Extended History, Precision Forecast'}</h3>
      </>
    )
    show = (
      <div>
        <SubscribeProcess
          plusUserSwitch={plusUserSwitch}
          user={user}
          subscription={(() => {
            // For existing subscribers switching plans
            if (plusUserSwitch && user.plus) {
              // Always use the selected tier when switching (for both upgrades and downgrades)
              return `awn-plus-${selectedTier === 'teams' ? 'for-teams' : 'account'}-${term}`
            }
            // For new subscriptions, use selected tier
            return `awn-plus-${selectedTier === 'teams' ? 'for-teams' : 'account'}-${term}`
          })()}
          setSubscription={newSub => {
            setAnnual(/yearly/.test(newSub))
          }}
          onSubscriptionChange={newSub => {
            // Update selected tier based on the new subscription from coupon code
            if (/for-teams/.test(newSub)) {
              setSelectedTier('teams')
            } else {
              setSelectedTier('plus')
            }
            // Also update annual/monthly state
            setAnnual(/yearly/.test(newSub))
          }}
          code={code}
          redeemCode={wantsGiftCode}
          useDiscountedPricing={paymentMethodChosen === 'cc' && !user.plus}
          forceIAP={paymentMethodChosen === 'iap'}
          paymentMethod={paymentMethodChosen === 'cc' ? 'stripe' : paymentMethodChosen === 'iap' ? 'iap' : 'auto'}
          startPolling={startPolling}
        >
          {proRate}
        </SubscribeProcess>
        <p className='privacy'>
          <a rel='noreferrer' href='https://nkhome.com/terms' target='_blank'>Terms of Service</a>
          <span> and </span>
          <a rel='noreferrer' href='https://nkhome.com/privacy' target='_blank'>Privacy Policy</a>
        </p>
      </div>
    )
  }
  return (
    <div className='payment-plus-subscription-modal'>
      <div>
        <header className='awn-logo'>
          {header}
        </header>
        {show}
      </div>
    </div>
  );
};

PlusSubscriptionModal.propTypes = {};
PlusSubscriptionModal.defaultProps = {};

PlusSubscriptionModal.displayName = 'PlusSubscriptionModal'

export default bindDeviceActions(PlusSubscriptionModal)
